<template>
  <div>
    <v-container fluid>

      <v-overlay :value="overlay" opacity="0">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-row>
        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-1">
              <v-skeleton-loader v-if="loading" type="text" width="100"></v-skeleton-loader>
              <div v-else>
                {{ stat.total }}
              </div>
              <v-spacer></v-spacer>
              <v-avatar color="blue" size="40">
                <v-icon dark>mdi-clipboard-list-outline</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text class="mt-3">
              Total saisies
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-1">
              <v-skeleton-loader v-if="loading" type="text" width="100"></v-skeleton-loader>
              <div v-else class="text-no-wrap">
                {{ stat.total_paquet_etiquete }}
              </div>
              <v-spacer></v-spacer>
              <v-avatar color="success" size="40">
                <v-icon dark>mdi-package-variant-closed</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text class="mt-3">
              Total paquets étiquetés
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-1">
              <v-skeleton-loader v-if="loading" type="text" width="100"></v-skeleton-loader>
              <div v-else class="text-no-wrap">{{ totalRestantAEtiqueter }}</div>
              <v-spacer></v-spacer>
              <v-avatar color="deep-orange" size="40">
                <v-icon dark>mdi-tag-multiple-outline</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text class="mt-3">
              Total restant à étiqueter
              <div class="caption grey--text">
                Objectif : {{ objectifTotal }} paquets
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-1">
              <v-skeleton-loader v-if="loading" type="text" width="100"></v-skeleton-loader>
              <div v-else>{{ stat.today }}</div>
              <v-spacer></v-spacer>
              <v-avatar color="primary" size="40">
                <v-icon dark>mdi-calendar-today-outline</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text class="mt-3">
              Saisies aujourd'hui
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card :disabled="overlay" :loading="overlay" class="rounded-lg shadow">
            <v-card-title>

              <div>
                <v-text-field v-model="keyword" append-icon="mdi-magnify" class="w-300" clearable
                              dense
                              filled
                              hide-details
                              placeholder="Recherche code POS..."
                              rounded single-line></v-text-field>
              </div>

              <v-spacer/>

              <v-tooltip color="primary" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" icon v-bind="attrs" @click="refresh" v-on="on">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualiser</span>
              </v-tooltip>

              <v-tooltip color="primary" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-1"
                         icon
                         v-bind="attrs"
                         @click="ExportExcel"
                         v-on="on">
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </template>
                <span>Exporter</span>
              </v-tooltip>
            </v-card-title>

            <!-- Filtres -->
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="filters.offre"
                            :items="offreItems"
                            clearable
                            dense
                            hide-details
                            label="Offre"
                            outlined></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="filters.wilaya"
                            :items="wilayaItems"
                            clearable
                            dense
                            hide-details
                            label="Wilaya"
                            outlined></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-select v-model="filters.tier"
                            :items="tierItems"
                            clearable
                            dense
                            hide-details
                            label="Tier"
                            outlined></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-menu v-model="dateFromMenu"
                          :close-on-content-click="false"
                          min-width="auto"
                          offset-y
                          transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="filters.date_from"
                                    clearable
                                    dense
                                    hide-details
                                    label="Du"
                                    outlined
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.date_from" @input="dateFromMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-menu v-model="dateToMenu"
                          :close-on-content-click="false"
                          min-width="auto"
                          offset-y
                          transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="filters.date_to"
                                    clearable
                                    dense
                                    hide-details
                                    label="Au"
                                    outlined
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.date_to" @input="dateToMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>

            <v-skeleton-loader v-if="loading" type="table"/>
            <v-card-text v-if="!loading && submissions.length === 0" class="text-center">
              <NoResult/>
            </v-card-text>
            <div v-if="!loading && submissions.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Code POS</th>
                    <th>Offre</th>
                    <th>Wilaya</th>
                    <th>Tier</th>
                    <th>Paquet étiqueté</th>
                    <th>Saisi par</th>
                    <th>Créé le</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in submissions" :key="item.id">

                    <td class="font-weight-medium blue--text">
                      {{ item.pos_code }}
                    </td>

                    <td class="font-weight-medium">
                      {{ item.offre || "-" }}
                    </td>

                    <td class="font-weight-medium">
                      {{ item.wilaya || "-" }}
                    </td>

                    <td class="font-weight-medium">
                      {{ item.tier || "-" }}
                    </td>

                    <td class="font-weight-medium">
                      {{ item.paquet_etiquete }}
                    </td>

                    <td class="font-weight-medium blue--text">
                      {{ item.supervisor?.name ?? "-" }}
                    </td>

                    <td>
                      {{ item.created_at }}
                    </td>

                    <td>
                      <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary" icon v-bind="attrs" @click="deleteItem(item.id)" v-on="on">
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Supprimer</span>
                      </v-tooltip>
                    </td>

                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-divider v-if="total > 10"/>

              <v-card-actions v-if="total > 10">

                <div>
                  <v-select v-model="per_page"
                            :items="[10,20,50,100,200,300,400,500]"
                            :style="{width: '120px'}"
                            dense
                            hide-details
                            label="Ligne par page"
                            outlined></v-select>
                </div>

                <v-spacer/>
                <v-pagination v-if="total>10"
                              v-model="pagination.current"
                              :length="pagination.total"
                              circle
                              total-visible="6"
                              @input="onPageChange"
                ></v-pagination>
              </v-card-actions>

            </div>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResult from "../../components/NoResult";
import {POTENTIEL_TOTAL} from "../boostingDashboardV3/posReference";

export default {
  components: {NoResult},
  data() {
    return {
      FILE_URL: process.env.VUE_APP_FILE_URL,

      overlay: false,
      loading: false,

      id: '',
      submissions: [],
      total: 0,
      per_page: 10,
      pagination: {
        current: 1,
        total: 0
      },
      keyword: '',

      // Filtres
      filters: {
        offre: null,
        wilaya: null,
        tier: null,
        date_from: null,
        date_to: null,
      },
      dateFromMenu: false,
      dateToMenu: false,

      // Options de filtres (référence statique)
      offreItems: ['OFFRE 1', 'OFFRE 2', 'OFFRE 3'],
      tierItems: ['TIER 1', 'TIER 2', 'TIER 3'],
      wilayaItems: [
        'AIN-TEMOUCHENT', 'ALGER', 'ANNABA', 'CONSTANTINE',
        'ORAN', 'SIDI BEL ABBES', 'TIZI OUZOU'
      ],

      stat: {}
    }
  },
  computed: {
    // Objectif global de la campagne, issu du fichier de référence POS
    objectifTotal() {
      return POTENTIEL_TOTAL
    },
    totalRestantAEtiqueter() {
      return Math.max(0, POTENTIEL_TOTAL - (Number(this.stat.total_paquet_etiquete) || 0))
    },
  },
  methods: {
    deleteItem(id) {
      this.id = id
      this.$confirm_dialog = true
    },
    getSubmissions() {
      this.loading = true
      this.$Progress.start()

      HTTP.get('/west-boost/pos-submissions?page=' + this.pagination.current, {
        params: {
          keyword: this.keyword,
          per_page: this.per_page,
          offre: this.filters.offre,
          wilaya: this.filters.wilaya,
          tier: this.filters.tier,
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
        }
      }).then((res) => {
        this.loading = false
        this.$Progress.finish()
        this.submissions = res.data.data.data

        this.stat = res.data.stat

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

      }).catch(err => {
        this.$Progress.fail()
        this.loading = false
        console.log(err)
      })
    },
    onPageChange() {
      this.getSubmissions();
    },
    ExportExcel() {
      let baseUrl = process.env.VUE_APP_FILE_URL
      let token = this.$store.state.user.token
      let userId = this.$store.state.user.id
      let params = new URLSearchParams({
        token: token,
        id: userId,
        keyword: this.keyword || '',
        offre: this.filters.offre || '',
        wilaya: this.filters.wilaya || '',
        tier: this.filters.tier || '',
        date_from: this.filters.date_from || '',
        date_to: this.filters.date_to || '',
      })
      let DownloadURL = baseUrl + '/export/excel/pos-submissions?' + params.toString()
      window.open(DownloadURL, '_blank')
    },
    refresh() {
      this.getSubmissions()
    }
  },
  created() {
    this.getSubmissions()
  },
  watch: {
    keyword() {
      this.pagination.current = 1
      this.getSubmissions();
    },
    per_page() {
      this.pagination.current = 1
      this.getSubmissions();
    },
    'filters.offre': function () {
      this.pagination.current = 1
      this.getSubmissions();
    },
    'filters.wilaya': function () {
      this.pagination.current = 1
      this.getSubmissions();
    },
    'filters.tier': function () {
      this.pagination.current = 1
      this.getSubmissions();
    },
    'filters.date_from': function () {
      this.pagination.current = 1
      this.getSubmissions();
    },
    'filters.date_to': function () {
      this.pagination.current = 1
      this.getSubmissions();
    },
    '$is_confirm': function (el) {
      if (el) {
        this.$is_confirm = false
        this.overlay = true
        this.$Progress.start()
        HTTP.delete('/west-boost/pos-submissions/delete/' + this.id).then(() => {
          let i = this.submissions.findIndex(item => item.id === this.id)
          this.$delete(this.submissions, i)
          this.$successMessage = 'Cette saisie a été supprimée avec succès'
          this.overlay = false
          this.$Progress.finish()
        }).catch(err => {
          this.overlay = false
          this.$Progress.fail()
          console.log(err)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
